import { Box } from '@chakra-ui/react'

export function EngIcon() {
    return (
        <Box>
            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.08337 10.5C2.08337 6.76809 2.08337 4.90211 3.24274 3.74274C4.40211 2.58337 6.26809 2.58337 10 2.58337C13.732 2.58337 15.598 2.58337 16.7573 3.74274C17.9167 4.90211 17.9167 6.76809 17.9167 10.5C17.9167 14.232 17.9167 16.098 16.7573 17.2573C15.598 18.4167 13.732 18.4167 10 18.4167C6.26809 18.4167 4.40211 18.4167 3.24274 17.2573C2.08337 16.098 2.08337 14.232 2.08337 10.5Z" stroke="currentColor" stroke-width="1.5" />
                <path d="M8.54004 7.87402H5.16602V13.126H8.54004" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.13818 10.4438H8.03076" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M11.04 13.2207V7.7793L14.862 13.2207V7.7793" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </Box>
    )
}
